<template lang="pug">
ul.list
  li.item(
    v-for="item in list"
    :class="{ withAvatar: showAvatar }"
  )
    .img(
      :style="{ 'background-image': `url(${item.photo})` }"
      v-if="showAvatar"
    )
    .content
      .author {{ item.fio }}
        raiting-default.stars(
          v-if="item.rate"
          :value="typeof item.rate === 'number' ? item.rate : parseInt(item.rate, 10)"
        )
        .date(v-if="!item.rate")
          | {{item.date}}
      p.text(v-if="item.text && item.rate")
        | {{ item.text }}
      p.text(v-else-if="item.text")
        | {{ item.text }}
      button-default(
        :to="item.to"
        :transform="false"
        :fill="false"
        v-if="item.to"
      ) Читать далее
</template>

<script>
import { ButtonDefault } from '@/components/parts/button';
import RaitingDefault from '@/components/parts/rating/default';

export default {
  components: {
    ButtonDefault,
    RaitingDefault,
  },
  props: {
    list: Array,
    showAvatar: Boolean,
  },
  computed: {
    rating() {
      let rate = Math.max(
        Math.min(5, typeof this.item.rate === 'number' ? this.item.rate : 0),
        0,
      );
      return new Array(5).map(item, index => index < rate);
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  list-style-type: none;
  margin: 0;
  padding: 0;

  .item {
    margin-top: 27px;
    position: relative;
    border-bottom: 1px solid #e8e8e8;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      border-bottom: none;
    }

    .img {
      display: none;
      position: absolute;
      top: -3px;
      left: 0;
      width: 66px;
      height: 66px;
      border: 3px solid #6e6bce;
      border-radius: 50%;
      overflow: hidden;
      background-position: center center;
      background-size: cover;
    }

    .content {
      .author {
        margin-right: 11px;
        font-weight: 600;
        font-size: 16px;
        color: #353535;
        user-select: text;
      }

      .stars {
        height: 20px;
        margin-bottom: -5px;
        margin-left: 10px;
        display: inline-block;
      }

      .date {
        margin-left: 10px;
        font-size: 12px;
        color: #797979;
        display: inline-block;
      }

      .text {
        margin-top: 6px;
        font-family: 'Open Sans', sans-serif;
        font-weight: 400;
        font-size: 14px;
        color: #666;
        line-height: 20px;
        -moz-user-select: text;
        user-select: text;
        cursor: text;
        margin-bottom: 10px;
        word-break: break-word;
      }
    }

    &.with-avatar {
      .img {
        display: block;
      }

      .content {
        margin-left: 108px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Short.vue?656030f2